import React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import LayoutContainer from 'components/Common/LayoutContainer'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { pipeSeparatorMessage } from 'LuxKit/intl/separators'
import TextLink from 'LuxKit/TextLink'
import BodyText from 'LuxKit/Typography/BodyText'
import Caption from 'LuxKit/Typography/Caption'

const RelatedItemsGrid = styled(LayoutContainer)`
  ${mediaQueryUp.tablet} {
    margin-top: ${rem(16)};
    padding-bottom: ${rem(40)};
  }
`

const RelatedItems = styled(Caption)`
  margin-top: ${rem(12)};
  display: flex;
  flex-direction: column;

  > * + * {
    margin-top: ${rem(8)};
  }

  ${mediaQueryUp.tablet} {
    margin-top: ${rem(8)};
    display: block;

    > * + * {
      margin-left: ${rem(16)};
      margin-top: 0;
    }
  }
`

const Separator = styled(BodyText)`
  display: none;

  ${mediaQueryUp.tablet} {
    display: inline;
  }
`

interface Props {
  items: Array<{ text: string, url: { to: string } }>
  title?: string
}

function DestinationPageRelatedTravelItems({ items, title }: Props) {
  const intl = useIntl()
  const defaultTitle = intl.formatMessage({
    id: 'Ox3C4GIS9e',
    defaultMessage: 'Related Travel',
    description: 'Default title for the related travel items section on the destination product page',
  })

  return <RelatedItemsGrid>
    <BodyText variant="large" weight="bold">{title || defaultTitle}</BodyText>
    <RelatedItems variant="medium">
      {items.map((item, index) => <React.Fragment key={item.text}>
        {index > 0 && <Separator variant="large" forwardedAs="span" colour="neutral-four">&nbsp;{intl.formatMessage(pipeSeparatorMessage)} </Separator>}
        <TextLink to={item.url.to}>{item.text}</TextLink>
      </React.Fragment>,
      )}
    </RelatedItems>
  </RelatedItemsGrid>
}

export default React.memo(DestinationPageRelatedTravelItems)
